var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-avatar',{attrs:{"color":`${_vm.getMaterialColor(_vm.color)} lighten-5`,"rounded":_vm.rounded,"size":_vm.size ? _vm.size : _vm.small ? 34 : 48}},[_c('v-icon',{attrs:{"color":_vm.color,"small":_vm.small}},[_vm._v(" mdi-"+_vm._s(_vm.icon))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }